import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ListBuilder from '../../../components/listBuilder';
import ErrorModal from '../../../components/errorModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../../helpers/linkHelper';
import { API_ENDPOINT } from '../../../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import viewIcon from '../../../assets/svg/eye.svg';
import historyIcon from '../../../assets/svg/history-icon.svg';
import editPaymentIcon from '../../../assets/svg/edit-payment-icon.svg';
import cancelPaymentIcon from '../../../assets/svg/cancel-payment-icon.svg';
import addIcon from '../../../assets/svg/add-icon.svg';

import questionaryIcon from '../../../assets/svg/questionary-mob.svg';
import caseIcon from '../../../assets/svg/case-mob.svg';
import priceIcon from '../../../assets/svg/payment-icon.svg';
import paymentMethodIcon from '../../../assets/svg/payment-method-icon.svg';
import calendarIcon from '../../../assets/svg/calendar-mob.svg';
import infoIcon from "../../../assets/svg/notes-icon.svg";


import xIcon from '../../../assets/svg/x.svg';
import garbageIcon from '../../../assets/svg/garbage.svg';
import walletIcon from '../../../assets/svg/wallet.svg';
import warrning from '../../../assets/svg/warrning.svg';
import attachInvoice from '../../../assets/svg/attach.svg'
import edit from '../../../assets/svg/edit.svg'
import handled from '../../../assets/svg/check.svg';

import Payson from '../../../components/payson';
import Swish from '../../swish';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import PdfSave from '../../../components/pdvSave';
import InfoModal from '../../../components/infoModal';
import striptags from 'striptags';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import downloadIcon from '../../../assets/svg/download.svg';
import deleteDocument from '../../../assets/svg/delete-document.svg'


import { getHumanReadableLabel, getHumanReadablePaymentMethod, getHumanReadableStatus } from '../helper';
import PreviewPayment from '../components/previewPayment';
import CustomFilters from '../components/customFilters';
import CustomFiltersPatient from '../components/customFiltersPatient';
import PayModal from '../payComponents/payModal';
import ListBuilderMob from '../../../components/listBuilderMob';
import { getTimeForPatient } from '../../referral/helper';
import { convertSplitDateToDivElements } from '../../calendar/helper';

function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}

class PaymentsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            items: [],
            windowWidth: typeof window !== 'undefined' ? window?.innerWidth : null,
            mobileTabs: [{ value: 'UNPAID', label: 'Unpaid'.translate(props.lang) }, { value: 'PAID', label: 'Paid'.translate(props.lang) }, { value: 'REFUNDED', label: 'Refunded'.translate(props.lang) }],
            customFiltersMobile: {
                status: ['UNPAID']
            }

        };
    }

    resizeWindow = () => {
        let windowWidth = this.state.windowWidth;
        if (typeof window != 'undefined' && window.innerWidth && Math.abs(windowWidth - window.innerWidth) > 50) {
            this.setState({ windowWidth: window.innerWidth })
        }
    }
    get = () => {
        const isMobileView = this.state.windowWidth && this.state.windowWidth < 768;
        const customFilters = isMobileView ? this.state.customFiltersMobile ?? {} : this.state.customFilters ?? {};
        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, sortField: 'sort.priority', sortType: 1, alias: localStorage.getItem('groupAlias') })).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
                this.state.useState ?
                    this.state.params
                    :
                    getSearchParams(this.props[0].location.search, {
                        entries: 10,
                        page: 0,
                        // groupId: this.props.selectedGroup,
                        // clinicId: this.props.selectedClinic,
                        filters: customFilters
                        // columnVisibility: this.state.tabIndex === 1 ? 'payments-unpaid' : this.state.tabIndex === 2 ? 'payments-paid' : null
                    })
            ).then((data) => {
                const resultFoundInStatuses = [...data?.resultFoundInStatuses ?? []];
                delete data.resultFoundInStatuses;
                let dataToSet = { ...data }
                if (dataToSet.page || dataToSet.items || dataToSet.total) {
                    dataToSet.loading = null;
                    let checkFilter = '';
                    if (dataToSet.resultFilter) {
                        checkFilter = String(dataToSet.resultFilter)
                        delete dataToSet.resultFilter;
                    }
                    let search = this.props[0].location.search;
                    let serachParams = getSearchParams(search);
                    let searchParamsFilter = '';
                    if (serachParams.filter) {
                        searchParamsFilter = serachParams.filter;
                    }
                    if (searchParamsFilter != checkFilter) {
                        delete dataToSet.page;
                        delete dataToSet.items;
                        delete dataToSet.total;
                        delete dataToSet.loading;
                    }
                }
                if (!dataToSet?.items?.length && !this.initialGetDone && resultFoundInStatuses?.length && this.state.customFiltersMobile?.status && isMobileView) {
                    let checkStatus = resultFoundInStatuses[0]?.indexOf('REFUNDED') > -1 ? ['REFUNDED', 'PARTIALLY_REFUNDED'] : [resultFoundInStatuses[0]];
                    if (checkStatus) {
                        dataToSet.customFiltersMobile = {
                            status: checkStatus
                        }

                    }
                }

                if (!this.initialGetDone) {
                    this.initialGetDone = true;
                }
                this.setState({
                    ...dataToSet,
                    // loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                    if (dataToSet.customFiltersMobile?.status) {
                        this.get();
                    }
                })
            })
        }

    }
    checkInitialState = () => {
        const initialState = this.props[0]?.location?.state ?? {};
        if (initialState?.message) {
            this.setState({ infoMessage: initialState.message });
            this.props[0].history.replace({ state: { ...initialState, message: null } });
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
            window.addEventListener('resize', this.resizeWindow);
        }

        if (this.props[0].location.state && this.props[0].location.state.fromCheckIn) {
            const filterCurrentDate = new Date().getFullYear() + '-' + String((new Date().getMonth() + 1)).padStart(2, '0') + '-' + String(new Date().getDate()).padStart(2, '0');
            // this.setState({
            //     filterDateFrom: filterCurrentDate,
            // }, () => {
            //     this.get();
            // })
            this.props[0].history.replace({ state: { fromCheckIn: null } });
            this.updateParams('filter', filterCurrentDate);
        }


        this.get();
        this.checkInitialState();


        this.interval = setInterval(() => {
            this.get();
        }, 60 * 1000);

        this.initializeSocket();

    }
    initializeSocket = () => {
        if (this.props.uData && this.props.socket && !this.state._registerEvents) {
            this.setState({
                _registerEvents: true
            }, () => {
                this.registerEvents();
            })
        } else {
            this.socketInterval = setInterval(() => {
                if (this.props.uData && this.props.socket && !this.state._registerEvents) {
                    if (this.socketInterval) {
                        clearInterval(this.socketInterval)
                    }

                    this.setState({
                        _registerEvents: true
                    }, () => {
                        this.registerEvents();


                    })
                }
            }, 150);
        }
    }
    registerEvents = async () => {
        this.props.socket.on('newPayment', (data) => {
            this.get();
        })
    }

    componentWillUnmount() {
        if (this.interval) clearInterval(this.interval);

        if (this.props.socket) {
            this.props.socket.removeListener('newPayment');
        }
        window.removeEventListener('resize', this.resizeWindow);

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }

        if (prevProps.selectedClinic != this.props.selectedClinic) {
            this.get();
        }

        if (prevState.windowWidth > 768 && this.state.windowWidth <= 768 || prevState.windowWidth <= 768 && this.state.windowWidth > 768) {
            this.get();
        }


    }


    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state
            })
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    { entries: 10, page: 0, sortField: 'sort.priority', sortType: 1 },
                    [
                        {
                            name: 'sortField', value: field
                        }
                        ,
                        {
                            name: 'sortType', value: type
                        }
                    ],
                    false));

        }
    }


    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0, sortField: 'sort.priority', sortType: 1 }, name, value, restart));
        }
    }
    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0, sortField: 'sort.priority', sortType: 1 }, fields, restart));
        }
    }


    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }

    getListData = () => {

        const currency = this.getCurrency();
        const defaultValue = 'N/A'.translate(this.props.lang)


        let listFields = [
            { type: 'text', name: 'caseNumber', label: 'Case ID'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'clinicInfo', label: 'Recipient'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'patient', label: 'Patient'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'visitReason', label: 'Visit reason'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'visitDate', label: 'Visit date'.translate(this.props.lang), allowSort: true, fieldWithDuration: true },
            { type: 'text', name: 'paymentMethod', label: 'Payment method'.translate(this.props.lang), allowSort: true }, // TODO
            { type: 'text', name: 'reference', label: 'Reference'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'price', label: 'Price'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'refundAmount', label: 'Refund Amount'.translate(this.props.lang), allowSort: true },
            // { type: 'text', name: 'vatValueString', label: 'Varav moms'.translate(this.props.lang), allowSort: true },
            // { type: 'text', name: 'tsCreated', label: 'Created'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'status', label: 'Status'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'messagesToPatient', label: 'Message'.translate(this.props.lang), allowSort: false, colMaxWidth: 200 },
        ];
        let listMobileFields = [
            { type: 'title', name: 'clinicName' },
            { type: 'subtitle', name: 'clinicSubgroupName' },
            { type: 'subtitle', name: 'doctorName' },
            { type: 'item', name: 'visitReason', svg: questionaryIcon, condition: item => item?.visitReason && item?.visitReason !== defaultValue ? true : false },
            { type: 'item-right-header', name: 'paymentStatusAndNumber' },
            {
                type: 'item-right-header', name: 'isCheckedIn', condition: (item) => {
                    if (item?.caseData?.isMarkedForCheckIn) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            { type: 'item', name: 'visitDate', svg: calendarIcon, condition: item => item?.visitDate && item?.visitDate !== defaultValue ? true : false },
            { type: 'item', name: '_price', svg: priceIcon, condition: item => item?.price ? true : false },
            { type: 'item', name: '_paymentMethod', svg: paymentMethodIcon, condition: item => item?.currentStatus?.paymentMethod?.key ? true : false },
            { type: 'item', name: 'messagesToPatient', svg: infoIcon, className: 'info-icon-mobile-list-builder', condition: item => item?.messagesToPatient && item?.messagesToPatient !== defaultValue ? true : false },

        ];

        const items = this.state.items?.length ? this.state.items : [];
        const listItems = items?.map((item => {
            const caseData = item?.caseData || {};
            const doctorName = caseData?.doctorName ?? item?.createdByUser?.name ?? null;
            const { groupName, clinicName, clinicSubgroupName } = item?.clinicInfo || {};
            const groupId = item?.groupId;
            const clinicId = item?.clinicId;
            const { name: patientName, ssn: patientSSN, customId: patientCustomId } = item?.patientData || {};
            const amount = item?.amount?.value;
            const _currency = item?.amount?.currency || currency;
            const price = `${amount} ${_currency}`;
            const refundAmount = item?.amount?.refundAmount ? `${item.amount.refundAmount} ${_currency}` : defaultValue;


            const vatValue = item?.vat?.value ? Number(item.vat.value) : 0;
            const vat = typeof vatValue === 'number' ? vatValue?.toFixed(2) : '0.00';
            const vatValueString = `${vat} ${_currency}`;

            const basicInfo = item?.currentStatus ?? item?.status?.[0];
            const __status = item?.currentStatus?.status?.key ?? basicInfo?.status?.key;

            const paymentMethod = basicInfo?.paymentMethod?.key ?? defaultValue;


            const reference = basicInfo?.reference ?? defaultValue;

            let _labels = [];
            if (item?.labels?.length) {
                for (let i = item.labels.length - 1; i >= 0; i--) {
                    if (!_labels.find(el => el.label?.key === item.labels[i].label?.key)) {
                        _labels.push(item.labels[i]);
                    }
                }
                _labels = _labels.reverse();
            }
            const isPaymentCancelled = _labels?.filter(label => label?.label?.key === 'payment_cancelled')?.length ? true : false;
            const __statusName = getHumanReadableStatus(isPaymentCancelled ? 'CANCELLED' : __status, this.props.lang);

            const labels = _labels?.length ? _labels?.filter(label => [/*'payment_cancelled',*/ 'case_deleted', 'patient_deleted', 'free_card_rejected']?.includes(label?.label?.key)).map((label, lIdx) => {
                let _label = getHumanReadableLabel(label.label?.key, this.props.lang);
                const username = label?.user?.username ?? label?.user?.name ?? null;
                const time = label?.time?.se ?? null;
                let tooltip;
                if (username && time) {
                    tooltip = `${'Added by'.translate(this.props.lang)} ${username} ${time}`;
                }
                return (
                    <div key={lIdx} className='payment-label info-tooltip'>
                        {_label}
                        {/* {tooltip ? <div className='tooltip-text'>{tooltip}</div> : null} */}

                    </div>
                )
            }) : null;

            const paymentMethodStatus = item?.currentStatus?.paymentMethodStatus?.[this.props.lang] ?? null;
            const _dateFormat = caseData?.visitDate?.hideTimeFromThePatient ? this.props.dateFormat : `${this.props.dateFormat} HH:mm`;
            const _visitDateTs = caseData?.visitDate?.ts ?? null;
            const __visitDate = getTimeForPatient(_visitDateTs, caseData?.visitDate?.endTs, caseData?.visitDate?.hideTimeFromThePatient, caseData?.visitDate?.hideDurationForPatient, this.props.getStringDateTs, this.props.dateFormat, this.props.lang)

            const _visitDate = __visitDate ? __visitDate : _visitDateTs ? this.props.getStringDateTs(_visitDateTs, _dateFormat) : null;
            const messagesToPatient = item?.messagesToPatient?.filter(msg => msg.message)?.length ? item?.messagesToPatient?.filter(msg => msg.message) : null;
            const lastMessageToPatient = messagesToPatient?.length ? messagesToPatient[messagesToPatient.length - 1]?.message || '' : '';
            const hideChangePaymentMethodButton = isPaymentCancelled || (item?.paymentMethods?.length === 1 && item?.paymentMethods?.[0] === 'invoice' && item.attachedInvoice) ? true : false;

            return {
                ...item,
                _status: __status,
                caseNumber: item?.paymentNumber,
                clinicInfo: <div className='list-builder-field-clinic-info' style={{ minWidth: 100 }}>{clinicName}<span>{clinicSubgroupName ? <><br />{clinicSubgroupName}</> : null}{doctorName ? <><br />{doctorName}</> : null}</span></div>,
                patient:
                    <div className='list-builder-field-clinic-info' style={{ minWidth: 100 }}>
                        {patientName}
                        <span>
                            {patientSSN ? <><br />{patientSSN}</> : null}
                            {/* {patientCustomId?.[groupId] ? <><br />{patientCustomId[groupId]} </> : null} */}
                        </span>
                    </div>,
                visitReason: caseData?.questionaryName ?? defaultValue,
                visitDate: _visitDate ? <div>{convertSplitDateToDivElements(_visitDate)} <span style={{ fontSize: 14, whiteSpace: 'nowrap' }}>({"Timezone: Stockholm".translate(this.props.lang)})</span></div> : defaultValue,
                price: price ?? defaultValue,
                vatValueString: vatValueString ?? defaultValue,
                tsCreated: item.tsCreated ? this.props.getStringDateTs(item.tsCreated, this.props.dateFormat + ' HH:mm') : defaultValue,
                status: <div className='list-builder-field-status'>{__statusName ?? defaultValue} {labels}  {item?.caseData?.isMarkedForCheckIn ? <div className='check-in-event'>
                    <Isvg src={handled} width={14} height={14} />
                    <div>{'Checked in'.translate(this.props.lang)}</div>
                </div> : null}</div>,
                paymentMethod: paymentMethod ?
                    paymentMethodStatus ?
                        <div className='payment-method-with-change'>
                            {getHumanReadablePaymentMethod(paymentMethod, this.props.lang)}
                            {!hideChangePaymentMethodButton ? <Button color='primary' onClick={() => this.openPayModal(item)}>{'Change payment method'.translate(this.props.lang)}</Button> : null}
                        </div>
                        :
                        getHumanReadablePaymentMethod(paymentMethod, this.props.lang)
                    :
                    null,
                reference: reference,
                paymentMethodStatus: paymentMethodStatus,
                isCheckedIn: <div className='check-in-event' style={{ justifyContent: 'end', paddingTop: 5, paddingBottom: 5 }}>
                    <Isvg src={handled} width={20} height={20} />
                    <div>{'Checked in'.translate(this.props.lang)}</div>
                </div>,
                // mobile fields:
                clinicName: clinicName,
                clinicSubgroupName: clinicSubgroupName,
                doctorName: doctorName,
                _paymentMethod: paymentMethod ?
                    <div className='payment-method-with-change-mob'>
                        <div>{getHumanReadablePaymentMethod(paymentMethod, this.props.lang)}</div>
                        <div>{paymentMethodStatus}</div>
                    </div>
                    :
                    null,
                paymentStatusAndNumber: <div className='payment-number-and-status-mob'>
                    <div className={`payment-status payment-status-${__status.toLowerCase()}`}>{__statusName}</div>
                    {item?.paymentNumber}
                </div>,
                messagesToPatient: lastMessageToPatient?.trim() ? lastMessageToPatient : defaultValue,
                refundAmount: refundAmount,
                _price: `${price}${refundAmount !== defaultValue ? ` (${'Refunded'.translate(this.props.lang)}: ${refundAmount})` : ''}`,
                hideChangePaymentMethodButton: hideChangePaymentMethodButton
            }
        }))

        return {
            listFields,
            listItems,
            listMobileFields
        }
    }
    openPayModal = (item) => {
        this.setState({ payModal: item })
    }


    render() {
        const currency = this.getCurrency();

        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0, sortField: 'sort.priority', sortType: 1 })
        }


        const { listFields, listItems, listMobileFields } = this.getListData();
        const isMobileView = this.state.windowWidth && this.state.windowWidth < 768;
        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>

                {this.state.error ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>

                    : null}
                {
                    this.state.loadingExport ?
                        <div className="export-loader-wrap">
                            <div className="loader-wrap">
                                <Player
                                    autoplay={true}
                                    loop={true}
                                    renderer={'svg'}
                                    src="/lf30_editor_l5cxzdyf.json"
                                    style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                                ></Player>

                            </div>
                        </div>
                        :
                        null
                }


                <Container fluid>
                    <Row style={{ marginLeft: isMobileView ? 3 : null, marginRight: isMobileView ? 3 : null }}>
                        <div className='panel'>

                            <div className="panel-header" style={{ marginBottom: isMobileView ? 20 : 35 }}>
                                <h5 className="component-header">{'My payments'.translate(this.props.lang)}</h5>
                            </div>


                            <Col lg="12" className='col-no-padding'>


                                {

                                    isMobileView ?
                                        <>
                                            {/* <div className='list-builder-mob-tabs'>
                                                {
                                                    this.state.mobileTabs.map((tab, tIdx) => {
                                                        const isSelected = this.state.customFiltersMobile?.status?.includes(tab.value) ? true : false;
                                                        return (
                                                            <div
                                                                key={tIdx}
                                                                className={`list-builder-mob-tab ${isSelected ? 'list-builder-mob-tab-active' : ''}`}
                                                                onClick={() => {
                                                                    let _customFiltersMobile = JSON.parse(JSON.stringify(this.state.customFiltersMobile ?? {}));
                                                                    if (isSelected) {
                                                                        _customFiltersMobile.status = _customFiltersMobile.status?.filter(s => s !== tab.value);
                                                                    } else {
                                                                        _customFiltersMobile.status = _customFiltersMobile.status ? [..._customFiltersMobile.status, tab.value] : [tab.value];
                                                                    }
                                                                    this.setState({ customFiltersMobile: _customFiltersMobile }, () => {
                                                                        this.get();
                                                                    });
                                                                }}
                                                            >
                                                                {tab.label}
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div> */}
                                            <ListBuilderMob
                                                lang={this.props.lang}
                                                loading={this.state.loading}
                                                total={this.state.total}
                                                showNumeration={false}
                                                rawItems={this.state.items}
                                                loadMoreItems={() => {
                                                    this.updateParams('entries', Number(params?.entries) + 10)
                                                }}
                                                disableLoadMore={this.state.items && this.state.total && Number(this.state.total) <= this.state.items?.length}
                                                fields={listMobileFields}
                                                items={listItems}
                                                actions={[
                                                    {
                                                        component: <div className='list-builder-button-mob'>{'Pay now'.translate(this.props.lang)}</div>,
                                                        buttonClassName: 'blue-button-list-builder-mob',
                                                        onClick: item => {
                                                            this.openPayModal(item);
                                                        },
                                                        condition: (item) => {
                                                            const status = item?._status;
                                                            const allowedStatuses = ["UNPAID"];
                                                            const labels = item?.labels?.map(label => label.label?.key) || [];
                                                            const paymentMethodStatus = item?.paymentMethodStatus;

                                                            let condition = allowedStatuses?.indexOf(status) > -1 && !paymentMethodStatus ? true : false;
                                                            if (condition && (labels?.includes('payment_cancelled') || labels?.includes('patient_deleted') || labels?.includes('case_deleted'))) {
                                                                condition = false;
                                                            }
                                                            return condition;
                                                        }
                                                    },
                                                    {
                                                        component: <div className='list-builder-button-mob'>{'Change payment method'.translate(this.props.lang)}</div>,
                                                        buttonClassName: 'blue-button-list-builder-mob',
                                                        onClick: item => {
                                                            this.openPayModal(item);
                                                        },
                                                        condition: (item) => {
                                                            const status = item?._status;
                                                            const allowedStatuses = ["UNPAID"];
                                                            const labels = item?.labels?.map(label => label.label?.key) || [];
                                                            const paymentMethodStatus = item?.paymentMethodStatus;

                                                            let condition = allowedStatuses?.indexOf(status) > -1 && paymentMethodStatus ? true : false;
                                                            if (condition && (labels?.includes('payment_cancelled') || labels?.includes('patient_deleted') || labels?.includes('case_deleted'))) {
                                                                condition = false;
                                                            }
                                                            if (condition && item.hideChangePaymentMethodButton) {
                                                                condition = false;
                                                            }
                                                            return condition;
                                                        }
                                                    },
                                                    // {
                                                    //     renderComponent: (item) => {
                                                    //         const labels = item?.labels?.map(label => label.label?.key) || [];
                                                    //         let _label = labels?.includes('payment_cancelled') ? 'payment_cancelled' : labels?.includes('free_card_rejected') ? 'free_card_rejected' : labels?.includes('case_deleted') ? 'case_deleted' : labels?.includes('patient_deleted') ? 'patient_deleted' : null;
                                                    //         return (
                                                    //             <div className='list-builder-button-mob-wrap'>
                                                    //                 <div className='list-builder-button-mob'>{getHumanReadableLabel(_label, this.props.lang)}</div>
                                                    //             </div>

                                                    //         )
                                                    //     },
                                                    //     onClick: item => {
                                                    //         // do nothing, just for showing the button
                                                    //     },
                                                    //     condition: (item) => {
                                                    //         const status = item?._status;
                                                    //         const allowedStatuses = ["UNPAID"];
                                                    //         const labels = item?.labels?.map(label => label.label?.key) || [];

                                                    //         let condition = allowedStatuses?.indexOf(status) > -1 || true ? true : false;
                                                    //         if (condition && (/*labels?.includes('payment_cancelled') || */labels?.includes('patient_deleted') || labels?.includes('case_deleted') || labels?.includes('free_card_rejected'))) {
                                                    //             condition = true;
                                                    //         } else {
                                                    //             condition = false;
                                                    //         }
                                                    //         return condition;
                                                    //     }
                                                    // },
                                                    {
                                                        component: <div className='list-builder-button-mob'>{'Download invoice'.translate(this.props.lang)}</div>,
                                                        buttonClassName: 'blue-button-list-builder-mob',
                                                        onClick: (item) => {
                                                            const requestedInvoice = item?.currentStatus?.paymentMethod?.key === 'invoice' ? true : false;
                                                            const paymentMethodNotExists = !item?.currentStatus?.paymentMethod?.key ? true : false;

                                                            const attachedInvoiceExists = item?.attachedInvoice ? true : false;
                                                            if ((paymentMethodNotExists || requestedInvoice) && attachedInvoiceExists && typeof window !== 'undefined') {
                                                                let url = API_ENDPOINT + item.attachedInvoice;
                                                                window.open(url, '_blank')
                                                            }
                                                        },
                                                        condition: (item) => {
                                                            const status = item?._status;
                                                            const allowedStatuses = ["UNPAID"];
                                                            const paymentMethodStatus = item?.paymentMethodStatus;
                                                            const attachedInvoiceExists = item?.attachedInvoice ? true : false;
                                                            const paymentMethodNotExists = !item?.currentStatus?.paymentMethod?.key ? true : false;
                                                            const requestedInvoice = item?.currentStatus?.paymentMethod?.key === 'invoice' ? true : false;

                                                            let condition = allowedStatuses?.indexOf(status) > -1 && attachedInvoiceExists && (paymentMethodNotExists || requestedInvoice) ? true : false;
                                                            const labels = item?.labels?.map(label => label.label?.key) || [];

                                                            if (condition && labels?.includes('payment_cancelled')) {
                                                                condition = false;
                                                            }
                                                            return condition;
                                                        },
                                                    },
                                                    {
                                                        component: <div className='list-builder-button-mob'>{'Read more'.translate(this.props.lang)}</div>,
                                                        onClick: (item) => {
                                                            this.setState({ previewPayment: item })
                                                        },
                                                        condition: (item) => {
                                                            const status = item?._status;
                                                            const allowedStatuses = ["PAID", "REFUNDED", "PARTIALLY_REFUNDED"];
                                                            const labels = item?.labels?.map(label => label.label?.key) || [];
                                                            let condition = allowedStatuses?.indexOf(status) > -1 ? true : false;
                                                            return condition;
                                                        }
                                                    }

                                                ]}
                                                filterFields={[
                                                    {
                                                        name: 'Unpaid'.translate(this.props.lang), onClick: () => {
                                                            // let _customFiltersMobile = JSON.parse(JSON.stringify(this.state.customFiltersMobile ?? {}));
                                                            // let value = 'UNPAID';
                                                            // if (_customFiltersMobile.status?.includes(value)) {
                                                            //     _customFiltersMobile.status = _customFiltersMobile.status?.filter(s => s !== value);
                                                            // } else {
                                                            //     _customFiltersMobile.status = _customFiltersMobile.status ? [..._customFiltersMobile.status, value] : [value];
                                                            // }
                                                            // this.setState({ customFiltersMobile: _customFiltersMobile }, () => {
                                                            //     this.get();
                                                            // });
                                                            let _customFiltersMobile = JSON.parse(JSON.stringify(this.state.customFiltersMobile ?? {}));
                                                            let value = 'UNPAID';
                                                            if (!_customFiltersMobile.status?.includes(value)) {
                                                                _customFiltersMobile.status = [value];
                                                            }
                                                            this.setState({ customFiltersMobile: _customFiltersMobile }, () => {
                                                                this.get();
                                                            });
                                                        },
                                                        active: this.state.customFiltersMobile?.status?.includes('UNPAID') ? true : false
                                                    },
                                                    {
                                                        name: 'Paid'.translate(this.props.lang),
                                                        onClick: () => {
                                                            // let _customFiltersMobile = JSON.parse(JSON.stringify(this.state.customFiltersMobile ?? {}));
                                                            // let value = 'PAID';
                                                            // if (_customFiltersMobile.status?.includes(value)) {
                                                            //     _customFiltersMobile.status = _customFiltersMobile.status?.filter(s => s !== value);
                                                            // } else {
                                                            //     _customFiltersMobile.status = _customFiltersMobile.status ? [..._customFiltersMobile.status, value] : [value];
                                                            // }
                                                            // this.setState({ customFiltersMobile: _customFiltersMobile }, () => {
                                                            //     this.get();
                                                            // });
                                                            let _customFiltersMobile = JSON.parse(JSON.stringify(this.state.customFiltersMobile ?? {}));
                                                            let value = 'PAID';
                                                            if (!_customFiltersMobile.status?.includes(value)) {
                                                                _customFiltersMobile.status = [value];
                                                            }
                                                            this.setState({ customFiltersMobile: _customFiltersMobile }, () => {
                                                                this.get();
                                                            });
                                                        },
                                                        active: this.state.customFiltersMobile?.status?.includes('PAID') ? true : false
                                                    },
                                                    {
                                                        name: 'Refunded'.translate(this.props.lang),
                                                        onClick: () => {
                                                            // let _customFiltersMobile = JSON.parse(JSON.stringify(this.state.customFiltersMobile ?? {}));
                                                            // let value = 'REFUNDED';
                                                            // if (_customFiltersMobile.status?.includes(value)) {
                                                            //     _customFiltersMobile.status = _customFiltersMobile.status?.filter(s => s !== value);
                                                            //     _customFiltersMobile.status = _customFiltersMobile.status?.filter(s => s !== 'PARTIALLY_REFUNDED');
                                                            // } else {
                                                            //     _customFiltersMobile.status = _customFiltersMobile.status ? [..._customFiltersMobile.status, value, 'PARTIALLY_REFUNDED'] : [value, 'PARTIALLY_REFUNDED'];
                                                            // }
                                                            // this.setState({ customFiltersMobile: _customFiltersMobile }, () => {
                                                            //     this.get();
                                                            // });
                                                            let _customFiltersMobile = JSON.parse(JSON.stringify(this.state.customFiltersMobile ?? {}));
                                                            let value = 'REFUNDED';
                                                            if (!_customFiltersMobile.status?.includes(value)) {
                                                                _customFiltersMobile.status = [value, 'PARTIALLY_REFUNDED'];
                                                            }
                                                            this.setState({ customFiltersMobile: _customFiltersMobile }, () => {
                                                                this.get();
                                                            });
                                                        },
                                                        active: this.state.customFiltersMobile?.status?.includes('REFUNDED') ? true : false
                                                    },
                                                    {
                                                        name: 'Cancelled payments'.translate(this.props.lang),
                                                        onClick: () => {
                                                            let _customFiltersMobile = JSON.parse(JSON.stringify(this.state.customFiltersMobile ?? {}));
                                                            let value = 'payment_cancelled';
                                                            if (!_customFiltersMobile.status?.includes(value)) {
                                                                _customFiltersMobile.status = [value];
                                                            }
                                                            this.setState({ customFiltersMobile: _customFiltersMobile }, () => {
                                                                this.get();
                                                            });
                                                        },
                                                        active: this.state.customFiltersMobile?.status?.includes('payment_cancelled') ? true : false
                                                    }
                                                ]}
                                                params={params}
                                                sortField={params?.sortField}
                                                sortType={params?.sortType}
                                                updateSort={this.updateSort}
                                                updateParams={this.updateParams}
                                                updateMultipleParams={this.updateMultipleParams}
                                            />
                                        </>
                                        :
                                        <ListBuilder
                                            lang={this.props.lang}
                                            loading={this.state.loading}
                                            total={this.state.total}
                                            showNumeration={false}
                                            updateFilterField={this.state.updateFilterField}
                                            get={this.get}//columnVisibility
                                            fields={listFields}
                                            rawItems={this.state.items}
                                            items={listItems}
                                            upperCustomFilters={
                                                <CustomFiltersPatient
                                                    {...this.props}
                                                    availableStatuses={this.state.availableStatuses ?? []}
                                                    onChange={(data) => {
                                                        const _data = JSON.parse(JSON.stringify(data));
                                                        const customFilters = JSON.parse(JSON.stringify(this.state.customFilters ?? {}));
                                                        if (JSON.stringify(_data) !== JSON.stringify(customFilters)) {
                                                            this.setState({ customFilters: _data }, () => {
                                                                let currentPage = params?.page ? String(params.page) : '0';
                                                                if (currentPage === '0') {
                                                                    this.get();
                                                                } else {
                                                                    this.updateParams('page', 0);
                                                                }

                                                            });
                                                        }
                                                    }}
                                                    customFilters={this.state.customFilters}
                                                />
                                            }
                                            actions={
                                                [

                                                    {
                                                        component:
                                                            <div className="tabel-action-tooltip">
                                                                <Isvg src={viewIcon} style={{ width: 24, minWidth: 24 }} />
                                                                <div style={{ width: 180 }} className="chat-icons-tooltip">{'Receipt'.translate(this.props.lang)}</div>
                                                            </div>,
                                                        onClick: (item) => {
                                                            this.setState({ previewPayment: item })
                                                        },
                                                        condition: (item) => {
                                                            const status = item?._status;
                                                            const allowedStatuses = ["PAID", "REFUNDED", "PARTIALLY_REFUNDED"];
                                                            const labels = item?.labels?.map(label => label.label?.key) || [];
                                                            let condition = allowedStatuses?.indexOf(status) > -1 ? true : false;
                                                            return condition;
                                                        }

                                                    },
                                                    {
                                                        component:
                                                            <Button color='primary'>{'Pay now'.translate(this.props.lang)}</Button>,
                                                        onClick: (item) => {
                                                            this.openPayModal(item);
                                                        },
                                                        condition: (item) => {
                                                            const status = item?._status;
                                                            const allowedStatuses = ["UNPAID"];
                                                            const labels = item?.labels?.map(label => label.label?.key) || [];
                                                            const paymentMethodStatus = item?.paymentMethodStatus;

                                                            let condition = allowedStatuses?.indexOf(status) > -1 && !paymentMethodStatus ? true : false;
                                                            if (condition && (labels?.includes('payment_cancelled') || labels?.includes('patient_deleted') || labels?.includes('case_deleted'))) {
                                                                condition = false;
                                                            }
                                                            return condition;
                                                        }
                                                    },
                                                    {
                                                        renderComponent: (item) => {
                                                            const requestedInvoice = item?.currentStatus?.paymentMethod?.key === 'invoice' ? true : false;
                                                            const paymentMethodNotExists = !item?.currentStatus?.paymentMethod?.key ? true : false;
                                                            const attachedInvoiceExists = item?.attachedInvoice ? true : false;

                                                            return (
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                    <div>{item?.paymentMethodStatus}</div>
                                                                    {
                                                                        (paymentMethodNotExists || requestedInvoice) && attachedInvoiceExists ?
                                                                            <div className="tabel-action-tooltip">
                                                                                <Isvg src={downloadIcon} style={{ width: 24, minWidth: 24 }} />
                                                                                <div style={{ width: 180 }} className="chat-icons-tooltip">{'Download invoice'.translate(this.props.lang)}</div>
                                                                            </div>
                                                                            :
                                                                            null
                                                                    }

                                                                </div>

                                                            )
                                                        },
                                                        onClick: (item) => {
                                                            const requestedInvoice = item?.currentStatus?.paymentMethod?.key === 'invoice' ? true : false;
                                                            const paymentMethodNotExists = !item?.currentStatus?.paymentMethod?.key ? true : false;

                                                            const attachedInvoiceExists = item?.attachedInvoice ? true : false;
                                                            if ((paymentMethodNotExists || requestedInvoice) && attachedInvoiceExists && typeof window !== 'undefined') {
                                                                let url = API_ENDPOINT + item.attachedInvoice;
                                                                window.open(url, '_blank')
                                                            }
                                                        },
                                                        condition: (item) => {
                                                            const status = item?._status;
                                                            const allowedStatuses = ["UNPAID"];
                                                            const paymentMethodStatus = item?.paymentMethodStatus;
                                                            const attachedInvoiceExists = item?.attachedInvoice ? true : false;
                                                            const paymentMethodNotExists = !item?.currentStatus?.paymentMethod?.key ? true : false;
                                                            const requestedInvoice = item?.currentStatus?.paymentMethod?.key === 'invoice' ? true : false;

                                                            let condition = (allowedStatuses?.indexOf(status) > -1 && paymentMethodStatus) || ((paymentMethodNotExists || requestedInvoice) && attachedInvoiceExists) ? true : false;

                                                            const labels = item?.labels?.map(label => label.label?.key) || [];

                                                            if (condition && labels?.includes('payment_cancelled')) {
                                                                condition = false;
                                                            }
                                                            return condition;
                                                        },
                                                    }



                                                ]
                                            }
                                            params={params}
                                            sortField={params.sortField}
                                            sortType={params.sortType}
                                            updateSort={this.updateSort}
                                            updateParams={this.updateParams}
                                            updateMultipleParams={this.updateMultipleParams}
                                        ></ListBuilder>

                                }

                                {this.state.items?.length <= 0 ?
                                    <p className='no-conversations-p'>{"No payments".translate(this.props.lang)}</p> : null}
                            </Col>
                        </div>
                    </Row>


                </Container>

                {
                    this.state.previewPayment ?
                        <PreviewPayment
                            {...this.props}
                            isOpen={this.state.previewPayment?._id}
                            onClose={(callback) => {
                                this.setState({ previewPayment: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.payModal ?
                        <PayModal
                            {...this.props}
                            isOpen={this.state.payModal?._id}
                            onClose={(callback) => {
                                this.setState({ payModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.infoMessage ?
                        <InfoModal
                            isOpen={this.state.infoMessage}
                            toggle={() => this.setState({ infoMessage: null })}
                            header={'Info'.translate(this.props.lang)}
                            info={this.state.infoMessage}
                            buttons={[
                                <Button color='primary' onClick={() => {
                                    this.setState({ infoMessage: null })
                                }}>{'Close'.translate(this.props.lang)}</Button>
                            ]}
                        />
                        :
                        null

                }


            </div >
        );
    }
}

export default Page(PaymentsPage);
